import React from 'react';
import EditableField from 'src/components/fields/EditableField';
import { Select } from 'antd';

const { Option } = Select;

export interface SwitchSelectFieldProps {
  value: boolean;
  placeholder?: string;
  className?: string;
  onEditModeChange?: (e: boolean) => void;
  onSelect?: (e: boolean) => void;
}

const SwitchSelectField: React.FC<SwitchSelectFieldProps> = (props: SwitchSelectFieldProps) => {
  const { value, onSelect, onEditModeChange, className, placeholder } = props;
  return (
    <EditableField value={value ? 'Да' : 'Нет'} onEditModeChange={onEditModeChange} className={className}>
      <Select
        placeholder={placeholder}
        value={value ? 1 : 0}
        onSelect={e => onSelect && onSelect(!!e)}
        style={{ width: '100%' }}
        defaultOpen
        autoFocus
      >
        {[
          { label: 'Да', value: 1 },
          { label: 'Нет', value: 0 },
        ].map(l => (
          <Option key={l.label} value={l.value}>
            {l.label}
          </Option>
        ))}
      </Select>
    </EditableField>
  );
};

export default SwitchSelectField;
